module.exports = __webpack_public_path__ + "static/media/arrow-right-dark.d290ee1f.png";